import { render, staticRenderFns } from "./ActivationPage.vue?vue&type=template&id=18c50c44&scoped=true"
import script from "./ActivationPage.vue?vue&type=script&lang=js"
export * from "./ActivationPage.vue?vue&type=script&lang=js"
import style0 from "./ActivationPage.vue?vue&type=style&index=0&id=18c50c44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c50c44",
  null
  
)

export default component.exports